import Component from '../core/Component'
import Scroll from '../services/Scroll'

export default class ModalVideo extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            rawVideo: null,
            rawIframe: null,
            video: null,
        }

        this.video = null
    }

    prepare() {
        this.modal = Component.getFromElement(this.element.closest('[data-component="Modal"]'))
        if (!this.modal) {
            return
        }

        if (this.ref.video) {
            this.video = Component.getFromElement(this.ref.video)
        }

        this.modal.on('open', this.handleModalOpen)
        this.modal.on('close', this.handleModalClose)
        Scroll.on('resize-x', this.handleResize)
    }

    destroy() {
        this.stopVideo()

        this.modal.off('open', this.handleModalOpen)
        this.modal.off('close', this.handleModalClose)
        Scroll.off('resize-x', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    handleModalOpen = () => {
        this.resize()

        if (this.video) {
            this.video.resize()
            this.video.play()
        }

        const promise = this.ref.rawVideo?.play()
        if (promise) {
            promise.catch(error => {
                //modal otevreny pres url, nemuze byt autoplay se zvukem
            })
        }
    }

    handleModalClose = () => {
        this.stopVideo()
    }

    resize() {
        const box = this.element.getBoundingClientRect()
        let width = .85 * Math.min(window.innerHeight / box.height * box.width, window.innerWidth)
        if (width > 1920) {
            width = 1920
        }
        this.element.style.width = `${Math.floor(width)}px`
    }

    playVideo() {
        if (this.video) {
            this.video.clear()
        }
        if (this.ref.rawVideo) {
            this.ref.rawVideo.pause()
        }
        if (this.ref.rawIframe) {
            const src = this.ref.rawIframe.src
            this.ref.rawIframe.src = src
        }
    }

    stopVideo() {
        if (this.video) {
            this.video.clear()
        }
        if (this.ref.rawVideo) {
            this.ref.rawVideo.pause()
        }
        if (this.ref.rawIframe) {
            const src = this.ref.rawIframe.src
            this.ref.rawIframe.src = src
        }
    }
}
